import { render, staticRenderFns } from "./BillingDetailsPreview.vue?vue&type=template&id=531ae77d&scoped=true&"
import script from "./BillingDetailsPreview.vue?vue&type=script&lang=js&"
export * from "./BillingDetailsPreview.vue?vue&type=script&lang=js&"
import style0 from "./BillingDetailsPreview.vue?vue&type=style&index=0&id=531ae77d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ae77d",
  null
  
)

export default component.exports